<template>
  <div class="l-tabbar">
    <keep-alive>
      <router-view class="container" />
    </keep-alive>
    <van-tabbar :fixed="false" v-model="active" active-color="#e70" inactive-color="#999" @change="onChange">
      <van-tabbar-item v-for="(item, index) in navInfo" :key="index" :name="item.name">
        <span>{{ item.title }}</span>
        <template #icon="props">
          <img :src="props.active ? item.active : item.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import NavInfo from "@/components/NavInfo";
import router from "@/router";

export default {
  data() {
    return {
      active: "Home",
      navInfo: NavInfo,
      activeItem: {}
    };
  },
  methods: {
    onChange(event) {
      const activeItem = this.navInfo.filter(item => item.name === event)[0];
      this.activeItem = activeItem;
      if (activeItem.path.startsWith("//")) {
        location.href = activeItem.path;
      } else {
        router.push({ path: activeItem.path });
      }
    }
  },
  watch: {
    $route: {
      handler(to) {
        const activeItem = this.navInfo.filter(item => item.path === to.path)[0];
        this.active = activeItem.name;
      },
      immediate: true
    }
  },
  created() {
    !NavInfo[0].path.startsWith("//") &&
      NavInfo.unshift({
        name: "Bom",
        path: "//www.bom.ai/app",
        title: "Bom.Ai"
      });

    NavInfo.map(item => {
      item.active = require(`@/assets/images/tabbar/${item.name}-active.png`);
      item.inactive = require(`@/assets/images/tabbar/${item.name}.png`);
    });
  }
};
</script>
<style lang="scss">
.l-tabbar {
  position: relative;
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  .van-tabbar-item {
    padding: 5px 0;
    &__icon img {
      height: 25px;
    }
  }
}
.container {
  position: relative;
  height: 100%;
}
</style>
